import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import moment from "moment";
import { post } from "../../../../helpers/api_helper";
import CustomSelect from "../../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../../CustomControls/CustomFlatpickr";
import { warningMessage } from "../../CommonFunctions";
import {
  POST_BranchDDLList,
  POST_GetCustomerProjectList,
  POST_GetReportLedgerList,
} from "../../../../helpers/url_helper";

const CustomerLedgerReport = () => {
  const [showFilter, setShowFilter] = useState(true); //for report screen default true
  const [isLoading, setIsLoading] = useState(false);
  const [isReset, setIsReset] = useState(false);

  const [ledgerList, setLedgerList] = useState([]);
  const [customerProjectOptions, setCustomerProjectOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const typeOptions = [
    { label: "Summary", value: true },
    { label: "Detail", value: false },
  ];

  const currentDate = new Date();

  const validationSchemaFilter = Yup.object().shape({
    BranchIDEncrypt: Yup.string().required("Branch is required field"),
  });

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      FromDate: new Date(currentDate.setMonth(currentDate.getMonth() - 3)),
      ToDate: new Date(),
      BranchIDEncrypt: "",
      CustomerIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      IsSummaryReport: true,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      FromDate,
      ToDate,
      BranchIDEncrypt,
      CustomerIDEncrypted,
      CustomerName,
      CustomerProjectIDEncrypted,
      IsSummaryReport,
    },
  } = formikFilter;

  const handleValidSubmitFilter = (values) => {
    getData();
  };

  const getResetData = async () => {
    setIsLoading(true);

    formikFilter.setValues({
      FromDate: new Date(currentDate.setMonth(currentDate.getMonth() - 3)),
      ToDate: new Date(),
      BranchIDEncrypt: "",
      CustomerIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      IsSummaryReport: true,
    });

    setIsReset(true);
  };

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
    setLedgerList([]);
  }, [FromDate]);

  useEffect(() => {
    setLedgerList([]);
  }, [ToDate]);

  useEffect(() => {
    if (isReset == true) {
      getData();
      setIsReset(false);
    }
  }, [isReset]);

  const getBranchDDL = async () => {
    await post(POST_BranchDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      EmployeeIDEncrypted: "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setBranchOptions(
            response?.BranchList?.map((item) => ({
              label: item?.BranchName,
              value: item?.BranchIDEncrypted,
              IsBranchDefinationComplate: item?.IsBranchDefinationComplate,
            }))
          );
          if (response?.BranchList?.length > 0) {
            formikFilter.setFieldValue(
              "BranchIDEncrypt",
              response?.BranchList[0].BranchIDEncrypted
            );
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getData = async () => {
    setLedgerList([]);
    setIsLoading(true);

    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: BranchIDEncrypt,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      IsSummaryReport: IsSummaryReport,
    };

    await post(POST_GetReportLedgerList, payload)
      .then((response) => {
        setLedgerList(response?.List);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    setIsLoading(false);
  };

  //without any package Export to Excel
  const exportTableToExcel = () => {
    if (!BranchIDEncrypt) {
      formikFilter.setFieldError("BranchIDEncrypt", "Branch is required field");
      formikFilter.setFieldTouched("BranchIDEncrypt", true);
      return;
    }

    if (ledgerList?.length == 0) {
      warningMessage("There is no data to export!");
      return;
    }

    setIsLoading(true);
    // Get the table HTML
    const table = document.getElementById("Ledger-tbl");
    if (!table) return;

    const tableHTML = table.outerHTML.replace(/ /g, "%20");

    // Specify the data type
    const dataType = "application/vnd.ms-excel";

    // Define the file name
    const fileName = `Ledger_${
      IsSummaryReport == true ? "Summary" : "Detail"
    } - ${CustomerName}.xls`; //"table.xls";

    // Create a download link element
    const downloadLink = document.createElement("a");

    // Browser check to support Microsoft Excel file download
    if (navigator.msSaveOrOpenBlob) {
      const blob = new Blob(["\ufeff", tableHTML], {
        type: dataType,
      });
      navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Create a link to the file
      downloadLink.href = `data:${dataType}, ${tableHTML}`;

      // Setting the file name
      downloadLink.download = fileName;

      // Triggering the function
      downloadLink.click();
    }

    setIsLoading(false);
  };

  const getCustomerProjectDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            }))
          );
          if (
            response?.CustomerProjectDDLList?.length > 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted
            ).length == 0
          ) {
            formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getBranchDDL();
    getCustomerProjectDDL();
  }, []);

  useEffect(() => {
    getData();
  }, [BranchIDEncrypt]);

  const handleChangeType = (e) => {
    formikFilter.setFieldValue("IsSummaryReport", e?.value ?? "");
    setLedgerList([]);
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Ledger Report</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore me-2" aria-hidden="true"></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>

                  <Link
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={exportTableToExcel}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link>
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={2}>
                            <Field
                              label="Type"
                              name="IsSummaryReport"
                              placeholder={"Select Type"}
                              options={typeOptions}
                              component={CustomSelect}
                              isClearable={false}
                              onChange={handleChangeType}
                            />
                          </Col>

                          <Col lg={2}>
                            <label className="mb-1">Financial Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Branch"
                              name="BranchIDEncrypt"
                              placeholder={"Select Branch"}
                              options={branchOptions}
                              component={CustomSelect}
                              isClearable={false}
                              required
                            />
                          </Col>

                          <Col lg={3}>
                            <Field
                              label="Project"
                              name="CustomerProjectIDEncrypted"
                              placeholder={"Select Project"}
                              options={customerProjectOptions}
                              component={CustomSelect}
                              menuStyles={{
                                position: "absolute",
                                right: 0,
                              }}
                            />
                          </Col>

                          <Col lg={1}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <button
                                  className="btn btn-primary btn-sm mb-1"
                                  type="submit"
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <Row className="me-0">
                  <Col lg={7}>
                    <div className="table-responsive">
                      <div
                        id="Ledger-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                        style={{ height: "510px", overflowY: "auto" }}
                      >
                        <table
                          id="Ledger-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead className="fixedheader">
                            <tr className="clsLedgerReportExcel">
                              <td
                                colSpan={6}
                                style={{
                                  textAlign: "center",
                                  fontWeight: 600,
                                  border: 0,
                                }}
                              >
                                Ledger Report -
                                {IsSummaryReport == true ? "Summary" : "Detail"}
                              </td>
                            </tr>
                            <tr className="clsLedgerReportExcel">
                              <td
                                colSpan={6}
                                style={{
                                  textAlign: "center",
                                  fontWeight: 600,
                                }}
                              >
                                {`${CustomerName} - ${moment(FromDate)
                                  .format("DD-MMM-YYYY")
                                  .replace(/^\-/, "")} To ${moment(ToDate)
                                  .format("DD-MMM-YYYY")
                                  .replace(/^\-/, "")} [${
                                  AuthUser?.BranchName
                                }]`}
                              </td>
                            </tr>
                            <tr>
                              <th
                                width="10%"
                                style={{
                                  border: 0,
                                  borderTop: "1px solid lightgray",
                                  borderBottom: "1px solid lightgray",
                                }}
                              >
                                Date
                              </th>
                              <th
                                width="50%"
                                style={{
                                  minWidth: "250px",
                                  border: 0,
                                  borderTop: "1px solid lightgray",
                                  borderBottom: "1px solid lightgray",
                                }}
                              >
                                Particulars
                              </th>
                              <th
                                width="10%"
                                style={{
                                  border: 0,
                                  borderTop: "1px solid lightgray",
                                  borderBottom: "1px solid lightgray",
                                }}
                              >
                                Voucher Type
                              </th>
                              <th
                                width="10%"
                                style={{
                                  textAlign: "right",
                                  border: 0,
                                  borderTop: "1px solid lightgray",
                                  borderBottom: "1px solid lightgray",
                                }}
                              >
                                Voucher Number
                              </th>
                              <th
                                width="10%"
                                style={{
                                  textAlign: "right",
                                  border: 0,
                                  borderTop: "1px solid lightgray",
                                  borderBottom: "1px solid lightgray",
                                }}
                              >
                                Debit
                              </th>
                              <th
                                width="10%"
                                style={{
                                  border: 0,
                                  borderTop: "1px solid lightgray",
                                  borderBottom: "1px solid lightgray",
                                }}
                              >
                                Credit
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ledgerList?.map((item, index) => (
                              <>
                                {index < ledgerList?.length - 3 ? (
                                  <tr key={index}>
                                    <td style={{ border: 0 }}>
                                      {item?.TransactionDate}
                                    </td>

                                    {IsSummaryReport == false ? (
                                      <>
                                        {!item?.TransactionDate ? (
                                          <td
                                            style={{
                                              whiteSpace: "normal",
                                              fontWeight: 600,
                                              textAlign: "right",
                                              border: 0,
                                            }}
                                          >
                                            <i>{item?.Particulars}</i>
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              whiteSpace: "normal",
                                              fontWeight: 600,
                                              border: 0,
                                            }}
                                          >
                                            {item?.Particulars}
                                          </td>
                                        )}
                                      </>
                                    ) : (
                                      <td
                                        style={{
                                          whiteSpace: "normal",
                                          border: 0,
                                        }}
                                      >
                                        {item?.Particulars}
                                      </td>
                                    )}
                                    {IsSummaryReport == false ? (
                                      <td
                                        style={{
                                          fontWeight: 600,
                                          border: 0,
                                        }}
                                      >
                                        {item?.VoucherType}
                                      </td>
                                    ) : (
                                      <td
                                        style={{
                                          border: 0,
                                        }}
                                      >
                                        {item?.VoucherType}
                                      </td>
                                    )}

                                    {IsSummaryReport == false &&
                                    !item?.TransactionDate ? (
                                      <td
                                        style={{
                                          textAlign: "left",
                                          fontWeight: 600,
                                          border: 0,
                                        }}
                                      >
                                        <i>{item?.VoucherNumber}</i>
                                      </td>
                                    ) : (
                                      <td
                                        style={{
                                          textAlign: "right",
                                          border: 0,
                                        }}
                                      >
                                        {item?.VoucherNumber}
                                      </td>
                                    )}

                                    <td
                                      style={{
                                        textAlign: "right",
                                        border: 0,
                                      }}
                                    >
                                      {item?.DebitAmount}
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "right",
                                        border: 0,
                                      }}
                                    >
                                      {item?.CreditAmount}
                                    </td>
                                  </tr>
                                ) : (
                                  <tr key={index}>
                                    <td
                                      colSpan={4}
                                      style={{
                                        textAlign: "right",
                                        fontWeight: 600,
                                        border: 0,
                                        borderTop: "1px solid lightgray",
                                        borderBottom: "1px solid lightgray",
                                      }}
                                    >
                                      {item?.VoucherNumber} &nbsp;
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "right",
                                        fontWeight: 600,
                                        border: 0,
                                        borderTop: "1px solid lightgray",
                                        borderBottom: "1px solid lightgray",
                                      }}
                                    >
                                      {item?.DebitAmount}
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "right",
                                        fontWeight: 600,
                                        border: 0,
                                        borderTop: "1px solid lightgray",
                                        borderBottom: "1px solid lightgray",
                                      }}
                                    >
                                      {item?.CreditAmount}
                                    </td>
                                  </tr>
                                )}
                              </>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default CustomerLedgerReport;
